import { music24LocaleOf } from 'fym-shared/src/music24/music24Locales';
import { config } from '../../../config/config';

/**
 * The music24.com pages that the app links and that exist in every language of the site
 * (music24-website `src/i18n/locales.ts`, `TRANSLATED_EXACT_PATHS`). Every other page is English
 * only: its `/<locale>/...` address answers 404, so the app links its bare English address.
 *
 * The legal pages (`terms-of-service`, `privacy-policy`) are English only today. Add them here in
 * the same release that translates them on music24.com: the sign-in page then opens them in the
 * language of the page (QA 2026-10-28, lit-20).
 */
export const WEBSITE_PAGES_IN_EVERY_LANGUAGE: ReadonlySet<string> = new Set([
  '',
  'pricing',
  'about',
  'changelog',
  'help',
  'promote',
  'pitch',
  'analytics',
  'public-data',
  'teams',
  'fans',
  'managers',
  'labels',
  'signup',
]);

/**
 * The address of a music24.com page in the language of the app: `<site>/pricing` in English,
 * `<site>/de/pricing` in German (the site keeps English at the bare path and each other language
 * under its prefix). A page that is English only, or a language that the site does not have, gets
 * the English address.
 */
export function websitePageUrl(path: string, locale: string, siteUrl: string = config.smartLinksWebURL): string {
  const site = siteUrl.endsWith('/') ? siteUrl : `${siteUrl}/`;
  const page = path.replace(/^\/+/, '');
  const language = music24LocaleOf(locale);
  const isTranslated = WEBSITE_PAGES_IN_EVERY_LANGUAGE.has(page.split(/[?#]/)[0] ?? '');
  const prefix = language === null || language === 'en' || !isTranslated ? '' : `${language}/`;
  return `${site}${prefix}${page}`;
}
